import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import { RepoUrlPickerState } from '../../interfaces/RepoUrlPickerState';

interface RepositoryNameProps {
  repoName?: string;
  onChange: (state: RepoUrlPickerState) => void;
  rawErrors: string[];
}

export default function RepositoryName(
  props: Readonly<RepositoryNameProps>,
): JSX.Element {
  const { repoName, onChange, rawErrors } = props;

  return (
    <FormControl
      margin="normal"
      required
      error={rawErrors?.length > 0 && !repoName}
    >
      <InputLabel htmlFor="repoNameInput">
        Azure DevOps Git Repository Name
      </InputLabel>
      <Input
        id="repoNameInput"
        onChange={e => onChange({ repoName: String(e.target.value) })}
        value={repoName}
        ata-testid="azure-devops-repository-name"
      />
      {repoName && (
        <FormHelperText>
          Input the new azure devops repository name without prefix
        </FormHelperText>
      )}
    </FormControl>
  );
}
